import { useState, useEffect } from "react";

const navLinks = [
  { id: "hero", label: "首屏" },
  { id: "live", label: "正在直播" },
  { id: "hot", label: "热搜瓜榜" },
  { id: "category", label: "吃瓜分类" },
  { id: "deep", label: "深度爆料" },
  { id: "voice", label: "吃瓜口碑" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-colors ${scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"}`}>
      <nav className="mx-auto flex h-16 md:h-[72px] items-center justify-between px-4 md:px-8">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap" onClick={(e) => { e.preventDefault(); go("hero"); }}>
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg"></i>
          </span>
          <span className="font-display text-xl md:text-2xl tracking-wide text-foreground-950">
            爆瓜台<span className="text-accent-500"> · </span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <a key={l.id} href={`#${l.id}`}
              onClick={(e) => { e.preventDefault(); go(l.id); }}
              className="rounded-full px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-200/70 hover:text-primary-600 transition whitespace-nowrap">
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button onClick={() => go("live")}
            className="hidden md:flex items-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-accent-500 px-4 py-2 text-sm font-semibold text-background-50 hover:opacity-90 transition">
            <i className="ri-live-line"></i> 进入瓜场
          </button>
          <button aria-label="打开导航" onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300/70 text-foreground-950 lg:hidden">
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50/98 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a key={l.id} href={`#${l.id}`} onClick={(e) => { e.preventDefault(); go(l.id); }}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-200/70">
                {l.label}
              </a>
            ))}
            <button onClick={() => go("live")}
              className="mt-2 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50">
              <i className="ri-live-line"></i> 进入瓜场
            </button>
          </div>
        </div>
      )}
    </header>
  );
}